/* Preserve existing header links on the native Foamberry templates. */
function foamberrySectionLinks() {
  if (!document.querySelector('.foamberry-native-marker')) return;
  for (const [anchor, section] of [['fbx-action','action'],['fbx-faq','faq'],['fv-action','action'],['fv-faq','faq']]) {
    const target = document.querySelector(`#MainContent [id$="__${section}"]`);
    if (target) document.querySelectorAll(`a[href="#${anchor}"]`).forEach(link => link.href = `#${target.id}`);
  }
}
foamberrySectionLinks();
document.addEventListener('shopify:section:load', foamberrySectionLinks);
